import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  ModelIcon,
  PersonIcon,
  PortfolioIcon,
  TransactionIcon,
} from "src/components/CustomSVG";
import {
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  makeStyles,
  Hidden,
} from "@material-ui/core";
import { useProfile } from "src/utils/customHook";
import { BROKERS } from "src/context/constants";
import { useGuess } from "src/hooks";
import AuthenPopup from "src/components/PopUp/AuthenPopup";
import { Adb } from "@material-ui/icons";
import { BROKERS as BROKER_INFOS } from "src/context/constants/brokerInfo";

const BAR_HEIGHT = 64;
const SCROLL_SPEED_THRESHOLD = 20;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    transition: "transform 0.2s",
  },
  nav: {
    height: `${BAR_HEIGHT}px`,
  },
}));

const AppBar = () => {
  const classes = useStyles();
  const profile = useProfile();
  const { isBitkubGuess } = useGuess();
  const [showAppBar, setShowAppBar] = useState(true);
  const [openPopup, setOpenPopup] = useState(false);
  const [initialPopup, setInitialPopup] = useState<"login" | "regis">("login");

  const isBitkub =
    profile?.broker.name.toLowerCase() === BROKER_INFOS.bitkub.name;

  // calculate scroll speed and direction
  const checkScrollSpeed = (() => {
    let lastPos: number | null,
      newPos: number | null,
      timer: NodeJS.Timeout,
      delta: number;

    function clear() {
      lastPos = null;
      delta = 0;
    }

    clear();

    return () => {
      const wrapper = document.querySelector("#layout-wrapper");
      if (wrapper) {
        newPos = wrapper.scrollTop;
        if (lastPos != null) {
          delta = newPos - lastPos;
        }
        lastPos = newPos;
        clearTimeout(timer);
        timer = setTimeout(clear, 50);
        return delta;
      }
      return 0;
    };
  })();

  useEffect(() => {
    const handleScrollEventListener = () => {
      const speed = checkScrollSpeed();

      if (speed > SCROLL_SPEED_THRESHOLD) {
        setShowAppBar(false);
      } else if (speed < -SCROLL_SPEED_THRESHOLD) {
        setShowAppBar(true);
      }
    };

    const wrapper = document.querySelector("#layout-wrapper");

    if (wrapper) {
      wrapper.addEventListener("scroll", handleScrollEventListener);

      return () => {
        wrapper.removeEventListener("scroll", handleScrollEventListener);
      };
    }
    //eslint-disable-next-line
  }, []);

  const onClickLogin = (e: any) => {
    setOpenPopup(true);
    setInitialPopup("login");
  };

  const handleClose = () => {
    setOpenPopup(false);
  };

  const getBottomNav = (dest: string, icon: React.ReactNode) => {
    const navAction = profile
      ? { component: RouterLink, to: dest }
      : { onClick: onClickLogin };
    return (
      <BottomNavigationAction
        {...navAction}
        label="account"
        value="account"
        icon={icon}
      />
    );
  };

  return (
    <Hidden lgUp>
      <Paper
        className={classes.root}
        style={{
          transform: `translateY(calc(${
            showAppBar ? "0" : "1"
          } * ${BAR_HEIGHT}px))`,
        }}
      >
        <AuthenPopup
          open={openPopup}
          onClose={handleClose}
          initialPopup={initialPopup}
        />
        <BottomNavigation className={classes.nav}>
          {isBitkub && (
            <BottomNavigationAction
              component={RouterLink}
              to="rebalance"
              label="rebalance"
              value="rebalance"
              icon={<Adb />}
            />
          )}
          {isBitkubGuess && getBottomNav("rebalance", <Adb />)}

          <BottomNavigationAction
            component={RouterLink}
            to="portfolio"
            label="portfolio"
            value="portfolio"
            icon={<PortfolioIcon />}
          />
          {!isBitkubGuess &&
            profile?.broker.name.toLowerCase() !== BROKERS.bitkub.name && (
              <>
                <BottomNavigationAction
                  component={RouterLink}
                  to="explore"
                  label="explore"
                  value="explore"
                  icon={<ModelIcon />}
                />
                {getBottomNav("transaction", <TransactionIcon />)}
              </>
            )}
          {getBottomNav("account", <PersonIcon />)}
        </BottomNavigation>
      </Paper>
    </Hidden>
  );
};

export default AppBar;
